import React from "react"

export default function TypeEmail({ value }) {
  return <div>{value} </div>
}
